import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CompetitorFilters } from "~/redux/types";

type SetFilterPayload = {
  key: keyof Partial<CompetitorFilters>;
  value:
    | CompetitorFilters[keyof CompetitorFilters]
    | { startDate: any; endDate: any };
};

const initialState: CompetitorFilters = {
  searchTerm: "",
  totalSales: "",
  storeCategory: "",
  priceRange: null,
  keywordFilters: {
    includeTitleKeywords: [],
    excludeTitleKeywords: [],
    includeDescriptionKeywords: [],
    excludeDescriptionKeywords: [],
    includeDomainKeywords: [],
    excludeDomainKeywords: [],
  },
};

const competitorSlice = createSlice({
  name: "competitorFilters",
  initialState,
  reducers: {
    loadFilters: (state, action: PayloadAction<Partial<CompetitorFilters>>) => {
      state.keywordFilters =
        action.payload.keywordFilters || initialState.keywordFilters;
      state.priceRange = action.payload.priceRange || initialState.priceRange;

      state.totalSales = action.payload.totalSales || initialState.totalSales;
    },
    resetFilters: () => initialState,
    setFilter: (state: any, action: PayloadAction<SetFilterPayload>) => {
      const { key, value } = action.payload;
      if (key === "priceRange") {
        state.priceRange = value;
      }
      if (key === "totalSales") {
        state.totalSales = value;
      }

      state[key] = value as CompetitorFilters[keyof CompetitorFilters];
    },
    setKeywords: (
      state,
      action: PayloadAction<{
        key: keyof CompetitorFilters["keywordFilters"];
        value: string[];
      }>
    ) => {
      state.keywordFilters[action.payload.key] = action.payload.value;
    },
  },
});

export const { setFilter, setKeywords, resetFilters, loadFilters } =
  competitorSlice.actions;
export default competitorSlice.reducer;
